module.exports = __webpack_public_path__ + "img/main.a10c4922.png";